import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { MessageTemplate, FormattedMessageTemplate } from "@idw-types/data/message-template";
import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { TemplateAvailabilityLevelTypes } from "@enums/template-availability-level-types";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";

export const formatMessageTemplates = (
    messageTemplates: Array<MessageTemplate>,
    companies: Array<AxnCompany>,
): Array<FormattedMessageTemplate> => {
    return messageTemplates.map(mt => formatMessageTemplate(mt, companies));
};
const getTemplateAvailabilityLevel = (companyId: string): TemplateAvailabilityLevelTypes => {
    if (!companyId) {
        return TemplateAvailabilityLevelTypes.GLOBAL;
    } else {
        return TemplateAvailabilityLevelTypes.ORGANIZATION;
    }
}

export const formatMessageTemplate = (
    messageTemplate: MessageTemplate,
    companies: Array<AxnCompany>,
): FormattedMessageTemplate => {
    const company = companies.find(c => c.id === messageTemplate.organizationID) || null;
    const languages: Partial<MultiLanguageWrapper<{ [key: string]: any }>> = {};
    let parsedLanguages: Partial<MultiLanguageWrapper<string>> = {};
    try {
        parsedLanguages = JSON.parse(messageTemplate.languages);
    } catch (error) {
        console.error("Failed to parse message template languages:", error);
    }
    if (parsedLanguages && Object.keys(parsedLanguages).length > 0) {
        (Object.keys(parsedLanguages) as Array<LocaleTypes>).forEach(locale => {
            try {
                const localeJSON = JSON.parse(parsedLanguages[locale]) || {};
                languages[locale] = localeJSON;
            } catch (error) {
                console.error(`Failed to parse locale JSON for ${locale}:`, error);
            }
        });
    }
    return {
        id: messageTemplate.id,
        name: messageTemplate.name,
        rpServiceID: messageTemplate.rpServiceID,
        status: messageTemplate.status,
        template: messageTemplate.template,
        sender: messageTemplate.sender,
        type: messageTemplate.type,
        languages,
        company,
        permissions: messageTemplate.permissions,
        uuid: messageTemplate.uuid,
        templateAvailabilityLevel: getTemplateAvailabilityLevel(messageTemplate.organizationID)
    };
};